import { apiService } from './api.service';
import { getGlobalTenantAlias } from './api.service';

class AuthService {
    async handleGoogleLogin(response) {
        try {
            const authResponse = await apiService.post('/auth/google/login', {
                token: response.credential
            });
            
            if (authResponse.access_token) {
                localStorage.setItem('access_token', authResponse.access_token);
                const userData = await this.verifySession();
                return { user: userData };
            }
            return null;
        } catch (error) {
            console.error('Google login failed:', error);
            
            // Extract a more user-friendly error message
            let errorMessage = 'Authentication failed. Please try again.';
            
            if (error.response) {
                // Handle specific error cases from the backend
                if (error.response.status === 404) {
                    errorMessage = 'Your Google account is not authorized for this tenant. Please contact your administrator.';
                } else if (error.response.status === 403) {
                    errorMessage = 'Access denied. You do not have permission to access this tenant.';
                } else if (error.response.data && error.response.data.detail) {
                    errorMessage = error.response.data.detail;
                }
            }
            
            // Create a new error with the improved message
            const enhancedError = new Error(errorMessage);
            enhancedError.originalError = error;
            throw enhancedError;
        }
    }

    async verifySession() {
        try {
            const token = localStorage.getItem('access_token');
            if (!token) {
                console.log('AuthService: No token found');
                return { valid: false };
            }

            const tenantAlias = getGlobalTenantAlias();
            if (!tenantAlias) {
                console.log('AuthService: No tenant alias available');
                return { valid: false };
            }

            console.log('AuthService: Verifying session with tenant:', tenantAlias);
            const response = await apiService.post('/auth/verify', {
                token,
                tenant_alias: tenantAlias
            });

            console.log('AuthService: Session verification response:', response);
            return response;
        } catch (error) {
            console.error('AuthService: Session verification failed:', error);
            return { valid: false, error: error.message };
        }
    }

    async logout() {
        try {
            const token = localStorage.getItem('access_token');
            if (token) {
                try {
                    await apiService.post('/auth/logout', null, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    console.log('AuthService: Logout successful');
                } catch (error) {
                    console.error('AuthService: Logout API call failed:', error);
                    // Continue with local logout even if API call fails
                }
            }
        } finally {
            // Always remove the token from localStorage
            localStorage.removeItem('access_token');
            console.log('AuthService: Token removed from localStorage');
        }
    }

    getStoredToken() {
        return localStorage.getItem('access_token');
    }

    isAuthenticated() {
        return !!this.getStoredToken();
    }
}

export const authService = new AuthService();
